export default {
  grid: {
    container: '130rem',
    gutter: '3.2rem'
  },
  border: {
    radiusMedium: '1.5',
    radius: '0.4rem'
  },
  font: {
    family: {
      headline:
        "Open Sans, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif",
      body: "Open Sans, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif"
    },
    light: 200,
    normal: 400,
    semiBold: 600,
    bold: 700,
    sizes: {
      xsmall: '1.2rem',
      small: '1.6rem',
      medium: '2.2rem',
      midlarge: '3.5rem',
      large: '4.5rem',
      xlarge: '7.5rem',
      xxlarge: '16.6rem'
    }
  },
  colors: {
    white: '#FFFFFF',
    midWhite: '#FCFCFC',
    black: '#000000',
    darkGray: '#464C52',
    lightGray: '#EAEAEA',
    purple: '#A044F1',
    darkPink: '#FE357B',
    lightPink: '#FEDDEE',
    red: '#F90D1B'
  },
  spacings: {
    xxsmall: '0.8rem',
    xsmall: '1.6rem',
    small: '2.4rem',
    medium: '3.2rem',
    large: '4.0rem',
    xlarge: '4.8rem',
    xxlarge: '5.6rem'
  },
  layers: {
    base: 10,
    menu: 20,
    overlay: 30,
    modal: 40,
    alwaysOnTop: 50
  },
  transition: {
    default: '0.3s ease-in-out',
    fast: '0.1s ease-in-out'
  }
} as const
